import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '会員一覧',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 3,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
